<template>
  <div class="container address-wrapper">
    <div class="address-group">
      <div class="address-list" v-for="address in addressData" :key="address.id">
        <div class="addressH">
          <span class="name">{{ address.linkman }}</span>
          <span class="phone">{{ address.linkphone }}</span>
        </div>
        <div class="addressC">{{ address.province }}{{ address.city }}{{ address.area }}{{ address.address }}</div>
        <div class="addressF">
          <span class="isdefault">{{address.isdefault === 1 ? '默认' : ''}}</span>
          <div class="addressbtn">
            <div class="editBtn" @click="$router.push({path: '/address/form', query: {id: address.id}})">
              <i class="iconfont iconbianji"></i>
              编辑
            </div>
            <div class="deleteBtn" @click="deletebtn(address.id)">
              <i class="iconfont iconshanchu"></i>
              删除
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="noaddress" v-show="isloaded && addressData.length < 1">
      <img src="../../assets/images/noaddress.png" alt="">
      <span>还没有地址信息，赶快添加一个吧！</span>
    </div>
    <div class="addAddressbtn">
      <van-button size="large" @click.native="$router.push('/address/form')">添加新地址</van-button>
    </div>
  </div>
</template>

<script>
import API from '../../interface/api'
export default {
  name: 'addressIndex',
  data() {
    return {
      addressData: [],
      isloaded: false
    }
  },
  created () {
    this.$toast.allowMultiple()
    this.getAddress()
  },
  methods: {
    getAddress () {
      const load = this.$toast({
        type: 'loading',
        duration: 0,
        loadingType: 'spinner',
        forbidClick: true
      })
      this.$fetch.get(API.MEMBERADDRESS).then(response => {
        // console.log(response)
        this.isloaded = true
        load.clear()
        if (response.status !== 200) {
          var msg = response.message? response.message : '收货地址获取失败，请刷新！'
          this.$toast.fail(msg)
          return
        }
        this.addressData = response.data
      }).catch(err => {
        console.log(err)
        load.clear()
      })
    },
    deletebtn (id) {
      this.$dialog.confirm({
        message: '是否删除该收货地址？'
      }).then(() => {
        const load = this.$toast({
          type: 'loading',
          duration: 0,
          loadingType: 'spinner',
          forbidClick: true
        })
        this.$fetch.get(API.MEMBERADDRESSDELETE, {
          id: id
        }).then(response => {
          load.clear()
          if (response.status !== 200) {
            var msg = response.message? response.message : '地址删除失败，请稍后重试！'
            this.$toast.fail(msg)
            return
          }
          // console.log(response)
          this.getAddress()
        }).catch(error => {
          console.log(error)
          load.clear()
        })
      }).catch(() => {
      })
    }
  }
}
</script>

<style lang="stylus">
</style>